import {Button} from "@/components/ui/button";
import {cn} from "@/lib/utils";

type SafelistingCoverageAnchorQuickPicksProps = {
  likelyAnchor: string;
  nextAnchor: string;
  currentLabel: string;
  nextLabel: string;
  sectionLabel: string;
  selectedFromAnchor: string | null;
  className?: string;
  onSelectAnchor: (anchor: string) => void;
};

export function SafelistingCoverageAnchorQuickPicks({
  likelyAnchor,
  nextAnchor,
  currentLabel,
  nextLabel,
  sectionLabel,
  selectedFromAnchor,
  className,
  onSelectAnchor,
}: SafelistingCoverageAnchorQuickPicksProps) {
  return (
    <div className={cn("flex flex-wrap items-center gap-2", className)}>
      <span className="text-muted-foreground text-xs font-medium">{sectionLabel}</span>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className={cn(
          "h-8 px-3 text-xs font-medium",
          selectedFromAnchor === likelyAnchor && "border-foreground bg-muted",
        )}
        onClick={() => onSelectAnchor(likelyAnchor)}
      >
        {currentLabel}
      </Button>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className={cn(
          "h-8 px-3 text-xs font-medium",
          selectedFromAnchor === nextAnchor && "border-foreground bg-muted",
        )}
        onClick={() => onSelectAnchor(nextAnchor)}
      >
        {nextLabel}
      </Button>
    </div>
  );
}
